import { render, staticRenderFns } from "./UpdateWhatsappBusinessChannel.vue?vue&type=template&id=5536c80a&scoped=true"
import script from "./UpdateWhatsappBusinessChannel.vue?vue&type=script&lang=js"
export * from "./UpdateWhatsappBusinessChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateWhatsappBusinessChannel.vue?vue&type=style&index=0&id=5536c80a&prod&lang=scss&scoped=true"
import style1 from "./UpdateWhatsappBusinessChannel.vue?vue&type=style&index=1&id=5536c80a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536c80a",
  null
  
)

export default component.exports